
import { Vue } from "vue-class-component";
import { Prop, Emit } from "vue-property-decorator";
import { LabelAndValue } from "../../types";
export default class DropdownButton extends Vue {
  @Prop() readonly items: LabelAndValue[] = [];
  @Emit("select")
  onChange(event: Event) {
    if (!event.target) return;
    return this.items.find(item => item.value === (event.target as HTMLSelectElement).value);
  }
}
